import apiClient from "./api";
const PRECIOSSUCURSAL_API_BASE_URL = "/preciosSucursal";
class PreciosSucursalService {
  getPreciosSucursal() {
    return apiClient.get(PRECIOSSUCURSAL_API_BASE_URL);
  }
  agregarPreciosSucursal(preciosSucursal) {
    return apiClient.post(PRECIOSSUCURSAL_API_BASE_URL, preciosSucursal);
  }
  updatePreciosSucursal(preciosSucursal, preciosSucursalId) {
    return apiClient.put(PRECIOSSUCURSAL_API_BASE_URL + "/" + preciosSucursalId, preciosSucursal);
  }
  deletePreciosSucursal(preciosSucursalId) {
    return apiClient.delete(PRECIOSSUCURSAL_API_BASE_URL + "/" + preciosSucursalId);
  }
  async getPreciosSucursalPorSucursal(sucursalId) {
    try {
      const response = await apiClient.get(`${PRECIOSSUCURSAL_API_BASE_URL}/sucursal/${sucursalId}`,);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new PreciosSucursalService();